import React from "react";
import List from "../../shared/List";
import helpers from "../../shared/helpers";
import config from "../../config";
import Popup from "../../shared/Popup";
import Form from "../../shared/Form";
import {ajaxPOST,ajaxGET} from "../../ajax";
import {eventLink} from "../Events/helpers";


export default function EventPromoList({type,slug,title,limit}){
  const [focusItem,setFocusItem] = React.useState(false);
  const [promoListKey,setPromoListKey] = React.useState(0);
  var deletePromoCode = async (promoCode) => {
    if(window.confirm("Are you sure you want to delete this promo code?")) {
      var result = await ajaxPOST(config.promoCodes.EVENTS_API+"/delete",{promoCodeID:promoCode.id});
      if(result.error){
         alert(result.error);
         return;
      }
      alert("Promo Code Deleted");
      window.location.reload(true);
      return result;
    }
  };

  return(<><Popup
      show={focusItem}
      hide={()=>{ setFocusItem(false); }}
      style={{width:"850px",maxWidth:"100%"}}
    > 
      <div className="details">
        <h4>Usage for <span style={{textTransform:"uppercase"}}>{focusItem[0]?.promoCode.toLowerCase()}</span></h4>
        <b>Used {focusItem.length} time{focusItem.length !== 1 ? `s` : ``}</b>
        <table >
          {focusItem && focusItem.map((line,i)=>{
            return (<tr key={`promoDetails${i}`}>
              <td>
                {line.email}
              </td>
              <td>
                <a href={eventLink(line)} target="_blank">{line.title}</a>
              </td>
              <td>
                Posted {helpers.date(line.timeAdded)}
              </td>
            </tr>)
          })}
      </table>


      </div>

    </Popup>

    <List
      title={title}
      limit={limit}
      key={promoListKey}
      urlGET={`${config.promoCodes.EVENTS_API}/${type}`}
      template={(i,index)=>{
        
        if(type == "available"){
          return (
            <tr key={`item${index}`}>
              <th style={{textDecoration:"underline"}}>{i.promocode || i.promoCode}</th>
              <td>{i.description}</td>
              <td>{i.discount} Discount</td>
              <td>
                {i.id ? (<>
                  <button onClick={()=>{deletePromoCode(i)}}>Delete</button>
                </>) : (<></>)}
              </td>
            </tr>
          );
        }
        else{
          var promoCount = i.length;
          
          return (
            <tr key={`item${index}`} onClick={()=>{
              setFocusItem([...i].sort((a, b) => new Date(b.timeAdded) - new Date(a.timeAdded)));
            }}>
              <th style={{textDecoration:"underline"}}>{i[0].promoCode}</th>
              <td>Used {promoCount} time{promoCount !== 1 ? `s` : ``}</td>
              
            </tr>
          );
        }
      }}
    />
  </>);
}
